import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'driveThumbnail',
})
export class DriveThumbnailPipe implements PipeTransform {
  transform(value: string | undefined | null, width: number = 400): string {
    if (!value) return '';

    // Regex para capturar o ID do arquivo em links do tipo /d/ID/view ou ?id=ID
    const match = value.match(/\/d\/([^/]+)/) || value.match(/[?&]id=([^&]+)/);

    if (match && match[1]) {
      const fileId = match[1];
      // Retorna a URL de miniatura otimizada com o tamanho desejado (ex: sz=w400)
      return `https://drive.google.com/thumbnail?id=${fileId}&sz=w${width}`;
    }

    // Se não for um link do drive, retorna o próprio valor (caso seja uma imagem local/externa)
    return value;
  }
}
